export enum ReportLogLevel {
    Interruptions = 0,
    TextNotes = 1,
    Information = 2,
    Hotkeys = 3,
    Features = 4,
}

export enum AnnotationAction {
    Added = 'Added',
    Deleted = 'Deleted',
    Modified = 'Modified',
}

export enum LogStatus {
    Success = 'Success',
    Failed = 'Failed'
}
